import { Route, Routes } from 'react-router-dom';
import { AppShell } from './AppShell';
import { HomePage } from '@/pages/HomePage';
import { ProductsPage } from '@/pages/ProductsPage';
import { PlatformPage } from '@/pages/PlatformPage';
import { SolutionsPage } from '@/pages/SolutionsPage';
import { PricingPage } from '@/pages/PricingPage';
import { NewsPage } from '@/pages/NewsPage';
import { NewsPostPage } from '@/pages/NewsPostPage';
import { ArticlesPage } from '@/pages/ArticlesPage';
import { ArticlePage } from '@/pages/ArticlePage';
import { AboutPage } from '@/pages/AboutPage';
import { ContactPage } from '@/pages/ContactPage';
import { AgentsPage } from '@/pages/AgentsPage';
import { LegalPage } from '@/pages/LegalPage';
import { NotFoundPage } from '@/pages/NotFoundPage';

export function App() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<HomePage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="platform" element={<PlatformPage />} />
        <Route path="solutions" element={<SolutionsPage />} />
        <Route path="pricing" element={<PricingPage />} />
        <Route path="news" element={<NewsPage />} />
        <Route path="news/:slug" element={<NewsPostPage />} />
        <Route path="articles" element={<ArticlesPage />} />
        <Route path="articles/:slug" element={<ArticlePage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="agents" element={<AgentsPage />} />
        <Route path="privacy" element={<LegalPage slug="privacy" />} />
        <Route path="terms" element={<LegalPage slug="terms" />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
